import * as React from "react";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import axios from "axios";
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, signOut, signInWithPopup, GoogleAuthProvider, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink, getAdditionalUserInfo } from "firebase/auth";


// Customize the theme/style
const mdTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#031c4a',
      paper: '#031c4a',
    },
    error: {
      main: '#060c43',
    },
    warning: {
      main: '#00e676',
    },
    success: {
      main: '#ffb74d',
    },
  },
});

export default function SignInPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
  const token =  window.localStorage.getItem('access_token');
  if(token) navigate("/Dashboard/Welcome");
  },[])

  const handleSubmit = (event) => {
    const data = new FormData(event.currentTarget);

    axios
      .post(
        `https://us-central1-ambient-systems.cloudfunctions.net/api/login`,
        {
          email: data.get("email"),
          password: data.get("password"),
        }
      )
      .then((response) => {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, data.get("email"), data.get("password"))
        .then((userCredential) => {
          const user = userCredential.user;
          if (!user.emailVerified) {
            alert("You haven't verified your email address! Please check your email inbox. \nIf you have verified and still get this, please refresh this page!")
            auth.signOut()
          } else {
            setEmail("");
            setPassword("");
            window.localStorage.setItem('access_token', response.data.token)
            window.localStorage.setItem('user_email', email)
            window.localStorage.setItem('uid', user.uid)
            console.log(response);
            window.location.reload()
          }
        })
      }).catch((error) => {
        console.log(error.message)
        alert(error.message)
      });
    event.preventDefault();

    console.log({
      email: data.get("email"),
      password: data.get("password"),
    });
  };

  function SignInGoogle() {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        if (getAdditionalUserInfo(result).isNewUser) {
          emailjs.send("teamService","template_cqyfsfh",{
            subject: "New registered user!",
            email: "The email address of the new user is " + user.email,
            message: "He registered at " + user.metadata.creationTime,
          }, "r87tnpnYE2FXwhAzx")
          emailjs.send("teamService","template_frf9asv",{
            subject: "New registered user!",
            email: "The email address of the new user is " + user.email,
            message: "He registered at " + user.metadata.creationTime,
          }, "r87tnpnYE2FXwhAzx")
          .then(() => {
            window.localStorage.setItem('access_token', result.user.accessToken)
            window.localStorage.setItem('user_email', user.email)
            window.localStorage.setItem('uid', user.uid)
            console.log(result);
            window.location.reload()
          })
        } else {
          window.localStorage.setItem('access_token', result.user.accessToken)
          window.localStorage.setItem('user_email', user.email)
          window.localStorage.setItem('uid', user.uid)
          console.log(result);
          window.location.reload()
        }
      }).catch((error) => {
        console.log(error.message)
        alert(error.message)
      });
  }

  function SignInWithLink() {
    var linkEmail = window.prompt('Please provide your email address for receiving magic link!')
    const auth = getAuth();
    sendSignInLinkToEmail(auth, linkEmail, {url: 'https://ambient-systems.web.app', handleCodeInApp: true})
    .then(() => {
      window.localStorage.setItem('emailForSignIn', linkEmail);
      alert("Link is sent successfully! Please check your inbox.")
    })
    .catch((error) => {
      console.log(error.message)
      alert(error.message)
    });
  }

  useEffect(() => {
    const auth = getAuth();
    if (isSignInWithEmailLink(auth, window.location.href)) {
      var saved_email = window.localStorage.getItem('emailForSignIn');
      if (!saved_email) {
        saved_email = window.prompt('You have checked the link via a different platform, please go back or provide your email again for confirmation');
      }
      signInWithEmailLink(auth, saved_email, window.location.href)
      .then((result) => {
        if (getAdditionalUserInfo(result).isNewUser) {
          emailjs.send("teamService","template_cqyfsfh",{
            subject: "New registered user!",
            email: "The email address of the new user is " + result.user.email,
            message: "He registered at " + result.user.metadata.creationTime,
          }, "r87tnpnYE2FXwhAzx")
          emailjs.send("freyService","template_frf9asv",{
            subject: "New registered user!",
            email: "The email address of the new user is " + result.user.email,
            message: "He registered at " + result.user.metadata.creationTime,
          }, "r87tnpnYE2FXwhAzx")
          .then(() => {
            window.localStorage.setItem('access_token', result.user.accessToken)
            window.localStorage.setItem('user_email', result.user.email)
            window.localStorage.setItem('uid', result.user.uid)
            console.log(result);
            window.location.reload()
          })
        } else {
          window.localStorage.removeItem('emailForSignIn');
          window.localStorage.setItem('access_token', result.user.accessToken)
          window.localStorage.setItem('user_email', result.user.email)
          window.localStorage.setItem('uid', result.user.uid)
          console.log(result);
          window.location.reload()
        }
      })
      .catch((error) => {
        console.log(error.message)
      });
    }
  }, []);

  /* User request to change his passport */
  const onPassportChange = () => {
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
    .then(() => {
      alert("Please check your inbox of current email address!")
      console.log("Send successfully!")
      window.localStorage.clear()
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage)
      alert(errorMessage)
    });
  }

  return (
    <ThemeProvider theme={mdTheme}>
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>

        {/* Text fields */}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <Button
            type="submit"
            fullWidth
            color="secondary"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>

        <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
            style={{
              backgroundColor: "#FFFAFA",
            }}
            onClick={SignInGoogle}
          >
            Sign In with Google
          </Button>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
            style={{
              backgroundColor: "#3CB371",
            }}
            onClick={SignInWithLink}
          >
            Sign in with magic link
          </Button>

          <Grid container>
            <Grid item>
              <Link href="SignUp" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
            <Grid item sx={{ ml: 9.5 }}>
              <Link onClick={onPassportChange} variant="body2">
                {"Forget password?"}
              </Link>
            </Grid>
          </Grid>

      </Box>
    </Container>
    </ThemeProvider>
  );
}
